enum PRODUCT_VARIANT_DOMAIN_TYPES {
  PRODUCT_VARIANT_LITE = 'PRODUCT_VARIANT_LITE',
  PRODUCT_VARIANT = 'PRODUCT_VARIANT',
}

export default PRODUCT_VARIANT_DOMAIN_TYPES
